module.exports = __webpack_public_path__ + "img/audios.18d3a5d6.svg";